import ListReplacementDelivery from "../../../../components/@documents/replacement_delivery/ListReplacementDelivery";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ReplacementDeliveriesPage() {

    return (
        <ListReplacementDelivery 
            routeType={routeTypes.workstation}
        />
    )
}